module.exports = __webpack_public_path__ + "assets/img/paycell.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/service-logos/paycell.svg
// module id = 414
// module chunks = 0